import { useIonActionSheet, useIonToast } from '@ionic/react';
import { OverlayEventDetail } from '@ionic/react/dist/types/components/react-component-lib/interfaces';
import { copyOutline, mailOutline, phonePortraitOutline } from 'ionicons/icons';
import { UAParser } from 'ua-parser-js';
import { Share } from '@capacitor/share';
import { useGetPublicInformationQuery } from '../api/SiteSettingsAPI.js';
export const useShare = ({ message, header = 'Invite a friend' }: { message: string; header?: string }) => {
	const [presentPostCreateOptions] = useIonActionSheet();

	const uap = new UAParser(navigator.userAgent);

	const { data: siteSettings } = useGetPublicInformationQuery();
	const postTypeOptions = {
		header,
		buttons: [
			{
				text: 'SMS',
				icon: phonePortraitOutline,
				data: {
					action: 'sms'
				}
			},
			{
				text: 'Email',
				icon: mailOutline,
				data: {
					action: 'email'
				}
			},
			{
				text: 'Copy',
				icon: copyOutline,
				data: {
					action: 'copy'
				}
			},
			{
				text: 'Cancel',
				role: 'cancel',
				data: {
					action: 'cancel'
				}
			}
		],
		onDidDismiss: ({ detail }: CustomEvent<OverlayEventDetail>) =>
			shareFallBack(detail?.data?.action ? detail?.data?.action : 'cancel')
	};
	const handleShare = async () => {
		try {
			if (!Share.canShare() || uap.getOS().name === 'Mac OS' || uap.getOS().name === 'Windows') {
				// Mac OS has very poor native sharing support, Chrome doesn't even provide it via navigator.share,
				// and Safari and Edge shouldn't.
				throw new Error('Not supported');
			}
			await Share.share({
				text: message
			});
		} catch (error) {
			if (!(error instanceof DOMException)) {
				presentPostCreateOptions(postTypeOptions);
			}
		}
	};

	const shareFallBack = async (shareType: string) => {
		if (shareType === 'sms') {
			window.location.href = `sms:&body=${message}`;
		} else if (shareType === 'email') {
			window.location.href = `mailto:?subject=Come and check out ${siteSettings?.siteName}&body=${message}`;
		} else if (shareType === 'copy') {
			try {
				await navigator.clipboard.writeText(`${message}`);
				presentShared({
					color: 'success',
					message: 'Share link copied',
					position: 'top',
					duration: 1500
				});
			} catch (err) {
				presentShared({
					color: 'danger',
					message: 'Share link not copied',
					position: 'top',
					duration: 1500
				});
			}
		}
	};

	const [presentShared] = useIonToast();
	return { handleShare };
};
